import type {StateCreator} from 'zustand'
import {CommentsPreference} from '@github-ui/diff-view-settings/types'

export type PreferencesSliceOpts = {
  commentsPreference?: CommentsPreference
}

export type PreferencesSlice = {
  commentsPreference: CommentsPreference

  preferencesActions: {
    setCommentsPreference: (preference: CommentsPreference) => void
  }
}

export const createPreferencesSlice =
  ({
    commentsPreference = CommentsPreference.Visible,
  }: PreferencesSliceOpts): StateCreator<PreferencesSlice, [['zustand/devtools', never]], [], PreferencesSlice> =>
  set => ({
    commentsPreference,

    preferencesActions: {
      setCommentsPreference: preference => {
        set({commentsPreference: preference}, undefined, 'setCommentsPreference')
      },
    },
  })
